import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  container: {
    padding: theme.spacing(2),
    overflowX: 'hidden',
    width: '100%'
  },
  title: {
    fontWeight: 500,
    padding: theme.spacing(2),
    color: theme.palette.primary.main,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: theme.accent.main,
    paddingBottom: theme.spacing(2)
  },
  actionButtons: {
    padding: theme.spacing(2),
    '@media (hover: none) and (pointer: coarse)': {
      '& .MuiButton-root': { minHeight: theme.spacing(5.5) }
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiButton-root': { minHeight: theme.spacing(5.5) }
    }
  }
}));
